/* Helper component for animating svg paths */
import React from 'react';
import { Motion, spring } from 'react-motion';

// regular expression to find numbers in a string. supports weird numbers like 0.5E1000 etc
const numberRE = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;

export default function TweenedPath(props) {
  const { path, opacity, opacitySpringOptions, ...restOfProps } = props;

  /* finds all numbers in the path string and create interpolators for them */
  const numbers = path.match(numberRE);

  const motionStyle = {};
  const defaultStyle = {};
  numbers.forEach((number, i) => {
    const key = `number${i}`;
    motionStyle[key] = spring(+number);
    defaultStyle[key] = +number;
  });

  motionStyle.opacity = spring(opacity, opacitySpringOptions);
  defaultStyle.opacity = 0;
  return (
    <Motion style={motionStyle} defaultStyle={defaultStyle}>
      {style => {
        /*
        for each number we want to tween, replace it with it's interpolated value
        a bit more involved to ensure we don't replace any values incorrectly
        */
        let tweenedPath = path.replace(numberRE, '|');
        numbers.forEach((number, i) => {
          const key = `number${i}`;
          const toValue = style[key] || number;
          tweenedPath = tweenedPath.replace('|', toValue);
        });
        return <path d={tweenedPath} opacity={style.opacity} {...restOfProps} />;
      }}
    </Motion>
  );
}

TweenedPath.defaultProps = {
  opacity: 1,
  opacitySpringOptions: null,
};
